import { render, staticRenderFns } from "./BaseSegmentedTabs.vue?vue&type=template&id=08431f0e&scoped=true"
import script from "./BaseSegmentedTabs.vue?vue&type=script&lang=js"
export * from "./BaseSegmentedTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseSegmentedTabs.vue?vue&type=style&index=0&id=08431f0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08431f0e",
  null
  
)

export default component.exports